import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  CustomErrorBase,
  CustomErrorVariant,
  handleError,
  HttpRequestMethods,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CommonConstants,
  EndpointKeysCommon,
  IDP_APPS,
  Libraries,
  MultiplePersonalizationEngineRequest,
  MultiplePersonalizationEngineResponse
} from '@com-delta-idp/mnx-skymiles-shared';

@Injectable({
  providedIn: 'root'
})
export class PersonalizationEngineService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  getMultipleContent = (
    request: MultiplePersonalizationEngineRequest
  ): Observable<MultiplePersonalizationEngineResponse> =>
    new ApiBuilder<
      MultiplePersonalizationEngineRequest,
      MultiplePersonalizationEngineResponse
    >(this.http, this.appConfig)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon['PERSONALIZATION_ENGINE_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(request)
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create()
      .pipe(
        map((response: MultiplePersonalizationEngineResponse) => {
          return this.existCustomError(response);
        })
      );

  existCustomError(
    response: MultiplePersonalizationEngineResponse | CustomErrorVariant
  ): MultiplePersonalizationEngineResponse {
    if ('error' in response) {
      const error: CustomErrorBase = {
        code: response.error.errorCode,
        message: response.error.errorMessage,
        developerMessage: ''
      };

      logCustomError(
        error,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeysCommon.PERSONALIZATION_ENGINE_URL
      );
      throw response;
    }
    return response;
  }
}
